import { KeycloakService } from "keycloak-angular";

 export function initializeKeycloak(keycloak: KeycloakService): () => Promise<boolean> {
    return () =>
      keycloak.init({
        config: {
          url: 'https://ap-tech-solns.com:8180',
          realm: 'wordpress',
          clientId: 'wordpress-client'
        }
        ,
        initOptions: {
         checkLoginIframe:true,
        checkLoginIframeInterval:25
        }
      });
  }